import React, { createContext, useState } from 'react';

export const SwrRequestKeysToMutateContext = createContext();

export const SwrRequestKeysToMutateProvider = ({ children }) => {
    const [requestKeysToMutate, setRequestKeysToMutate] = useState({
        goalTemplates: [],
        processTemplates: [],
        playbookTemplates: [],
        jobs: [],
        projects: [],
        threads: [],
        executions: [],
        folderDocs: [],
        bases: [],
        promptsInPlaybooks: [],
        chatPrompts: [],
        processes: [],
        playbooks: [],
        scenarios: [],
        bots: [],
        cycles: [],
    });

    return (
        <SwrRequestKeysToMutateContext.Provider
            value={{
                requestKeysToMutate,
                setRequestKeysToMutate,
            }}
        >
            {children}
        </SwrRequestKeysToMutateContext.Provider>
    );
};
